// extracted by mini-css-extract-plugin
var _1 = "UserMention-module__noAccessAvatar--iWulF";
var _2 = "UserMention-module__noAccessContent--ql0WY";
export { _1 as "noAccessAvatar", _2 as "noAccessContent" }
